import { Component, Inject } from '@angular/core';
import { StationModel } from '../../models/stationModel';
import { FormControl, Validators } from '@angular/forms';
import { RestAPIService } from 'src/app/services/restapi.service';
import { ToastService } from 'src/app/services/toaster.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-station-add-edit',
  templateUrl: './station-add-edit.component.html',
  styleUrl: './station-add-edit.component.css'
})
export class StationAddEditComponent {
  submitted: boolean = false;
  station: StationModel = new StationModel();
  name = new FormControl('', [Validators.required]);
  crsCode = new FormControl('', [Validators.required]);
  lat = new FormControl('', []);
  long = new FormControl('', []);

  constructor(public _restAPI: RestAPIService, private toast: ToastService, public dialogRef: MatDialogRef<StationAddEditComponent>, @Inject(MAT_DIALOG_DATA) public data: any){
    this._restAPI.loading  = false;
    this.station = JSON.parse(JSON.stringify(data.stationModel));
    localStorage["applyStationFilterValue"] = 'true';
  }

  async ngOnInit(){
    
  }
  
  closeDialog(): void {
    this.dialogRef.close(false);
  }

  async saveStation() {
    if(!this.name.invalid && !this.crsCode.invalid && !this.lat.invalid && !this.long.invalid){
      this._restAPI.loading  = true;
      let postData = {
          name: this.station.name,
          crsCode: this.station.crsCode,
          lat: this.station.lat,
          long: this.station.long
      };
      if (this.station.id != null && this.station.id.length > 0) {
        this._restAPI.put<string>(environment.apiURL + 'api/station/edit/' + this.station.id, postData).subscribe({
            next: (results) => {
              this._restAPI.loading  = false;
              this.dialogRef.close(true);
              this.toast.show("Station has been updated successfully");
            },
            error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
        });
      }
      else {
        this._restAPI.post<string>(environment.apiURL + 'api/station/add', postData).subscribe({
            next: (results) => {
              this._restAPI.loading  = false;
              this.dialogRef.close(true);
              this.toast.show("Station has been added successfully");
            },
            error: (error) => {this._restAPI.loading  = false;this.toast.error(error)}
        });
      }
    }
  }
}